import { useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import { getRecipientGoodIssue, getSenderGoodIssue, getGoodReceipt } from '../../Service/InventoryService';
import moment from 'moment';

const Transfer = () => {

    const navigate = useNavigate();
    const mTableSend = useRef();
    const mTableReceive = useRef();
    const mTableReceipt = useRef();
    const onAddData = () => {
        navigate("/inventorytransfer/create");
    }

    const onView = item => () => {
        navigate("view/" + item.id);
    };

    const onCreateReceipt = item => () => {
        navigate('/receipttransfer/create/' + item.id);
    };

    const onViewReceipt = item => () => {
        navigate('/receipttransfer/' + item.id);
    };

    const columns = [
        { id: 1, title: 'Stock Transfer', field: 'docnum', sortable: true, render: ({ docnum }) => `#${docnum}` },
        { id: 2, title: 'From WHS', field: 'fromwhsname', sortable: true },
        { id: 3, title: 'To WHS', field: 'towhsname', sortable: true },
        { id: 4, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23. You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03, 2023-04-01 16.04",  render: data => {
            // moment.locale('id');
            return moment(data.created_date).locale('id').format('ll LTS')
        } },
        {
            id: 5,
            title: 'Status',
            field: 'status',
            sortable: true,
            render: data => {
                var text = "";
                if (data.status == 'CANCELED') {
                    text = <span className="badge bg-red me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 8 }}>CANCELED</span>;
                } else if (data.status == 'CLOSED') {
                    text = <span className="badge bg-close me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 8 }}>CLOSED</span>;
                } else if (data.status == 'OPEN') {
                    text = <span className="badge bg-cyan me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 8 }}>OPEN</span>;
                }
                return text;
            },
        },
        {
            id: 6,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ width: 100 }}>
                        <a
                            onClick={onView(item)}
                            style={{
                                cursor: 'pointer',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-eye text-primary" />
                            <span className='text-primary ml-1' >View</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnsReceived = [
        { id: 1, title: 'Stock Transfer', field: 'docnum', sortable: true, render: ({ docnum }) => `#${docnum}` },
        { id: 2, title: 'From WHS', field: 'fromwhsname', sortable: true },
        { id: 3, title: 'To WHS', field: 'towhsname', sortable: true },
        { id: 4, title: 'Created Date', field: 'created_date', sortable: true },
        {
            id: 5,
            title: 'Status',
            field: 'status',
            sortable: true,
            render: data => {
                var text = "";
                if (data.status == 'CANCELED') {
                    text = <span className="badge bg-red me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 8 }}>CANCELED</span>;
                } else if (data.status == 'CLOSED') {
                    text = <span className="badge bg-close me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 8 }}>CLOSED</span>;
                } else if (data.status == 'OPEN') {
                    text = <span className="badge bg-cyan me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 8 }}>OPEN</span>;
                }
                return text;
            },
        },
        {
            id: 6,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ minWidth: 100 }}>
                        <a onClick={onCreateReceipt(item)}
                            className="btn btn-outline-success" >
                            <i className="fas fa-vote-yea" />
                            <span style={{ marginLeft: 10 }}>Receive</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnsReceipt = [
        { id: 1, title: 'Stock Receipt', field: 'docnum', sortable: true, render: ({ docnum }) => `#${docnum}` },
        { id: 2, title: 'From WHS', field: 'fromwhsname', sortable: true },
        { id: 3, title: 'To WHS', field: 'towhsname', sortable: true },
        { id: 4, title: 'Created Date', field: 'created_date', sortable: true },
        {
            id: 5,
            title: 'Status',
            field: 'status',
            sortable: true,
            render: data => {
                var text = "";
                if (data.status == 'RECEIPT') {
                    text = <span className="badge bg-success me-2" style={{ padding: 8, fontWeight: 'bold', width: 100 }}>
                        <i className="fas fa-vote-yea" /> RECEIPT</span>;
                } else if (data.status == 'CLOSED') {
                    text = <span className="badge bg-close me-2" style={{ fontSize: 10, padding: 8, fontWeight: 'bold' }}>CLOSED</span>;
                } else if (data.status == 'OPEN') {
                    text = <span className="badge bg-cyan me-2" style={{ fontSize: 10, padding: 8, fontWeight: 'bold' }}>OPEN</span>;
                }
                return text;
            },
        },
        {
            id: 6,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ minWidth: 100 }}>
                        <a
                            onClick={onViewReceipt(item)}
                            className="btn btn-outline-success"
                        >
                            <i className="fas fa-eye" />
                            <span style={{ marginLeft: 10 }}>View</span>
                        </a>
                    </div>
                );
            },
        },
    ];

    const onTabSendClick = () => {
        mTableSend.current.refresh();
    }

    const onTabReceiveClick = () => {
        mTableReceive.current.refresh();
    }

    const onTabReceiptClick = () => {
        mTableReceipt.current.refresh();
    }

    const propsTableSend = { columns, getData: getSenderGoodIssue, direction: 'desc', showIndex: true, showAddButton: true, onAddData };
    const propsTableReceive = { columns: columnsReceived, getData: getRecipientGoodIssue, direction: 'desc', showIndex: true };
    const propsTableReceipt = { columns: columnsReceipt, getData: getGoodReceipt, direction: 'desc', showIndex: true };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Stock Transfer</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <ul className="nav nav-tabs md-tabs" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" onClick={onTabSendClick} data-toggle="tab" href="#tab-send" role="tab" aria-selected="true">Send</a>
                                    <div className="slide"></div>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" onClick={onTabReceiveClick} data-toggle="tab" href="#tab-receive" role="tab" aria-selected="false">On Progress</a>
                                    <div className="slide"></div>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" onClick={onTabReceiptClick} data-toggle="tab" href="#tab-receipt" role="tab" aria-selected="false">Receipt</a>
                                    <div className="slide"></div>
                                </li>
                            </ul>
                            <div className="tab-content card-block">
                                <div className="tab-pane active" id="tab-send" role="tabpanel">
                                    <div className='table-responsive'>
                                        <MTable ref={mTableSend} {...propsTableSend} />
                                    </div>
                                </div>
                                <div className="tab-pane" id="tab-receive" role="tabpanel">
                                    <div className='table-responsive'>
                                        <MTable ref={mTableReceive} {...propsTableReceive} />
                                    </div>
                                </div>
                                <div className="tab-pane" id="tab-receipt" role="tabpanel">
                                    <div className='table-responsive'>
                                        <MTable ref={mTableReceipt} {...propsTableReceipt} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default Transfer;